if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {

      constructor() {
        super();
        this.initialized = false;
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.handleProductCardSwatchClick();
        this.handleProductCardVariantClick();
      }

      handleInsideLinkClick = (event) => {
        event.preventDefault();
      }

      fetchProduct(event) {

        event.preventDefault();


        fetch(event.target.dataset.productUrl + '?view=card-product--swatches')
        .then(response => response.text())
        .then(text => {

          const newHtml = new DOMParser().parseFromString(text, 'text/html').querySelector('product-card').innerHTML;

          if (newHtml !== null) {
            this.innerHTML = newHtml;
            this.handleProductCardSwatchClick();
            this.handleProductCardVariantClick();
          }

        })
        .catch(e => {
          console.error(e);
        });

      }

      handleProductCardSwatchClick() {
        const swatches = this.querySelectorAll('product-group product-group-swatch');
        swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.fetchProduct.bind(this));
          swatch.querySelector('a.product-group--item')?.classList.add('js-load');
          swatch.querySelector('a.product-group--item')?.addEventListener('click', this.handleInsideLinkClick);
        });
      }

      handleProductCardVariantClick() {
        let variants = this.querySelectorAll('.card-variant-selector button');
        let colourVariants = this.querySelectorAll('.shop-the-look__colour-variant .product-group--item');
        variants.forEach(variant => {
          variant.addEventListener('click', this.updateShopTheLookForm.bind(this));
        })
        colourVariants.forEach(variant => {
          variant.addEventListener('click', this.updateShopTheLookForm.bind(this));
        })
      }

      updateShopTheLookForm(e) {
        const colourItem = e.target.closest('.product-group--item');
        const sizeButton = e.target.closest('.card-variant-selector button');

        // colour variant clicked
        if (colourItem) {
          let colourVariants = this.querySelectorAll('.shop-the-look__colour-variant .product-group--item');
          colourVariants.forEach(variant => {
            variant.classList.remove('current');
          })
          colourItem.classList.add('current');

          this.querySelectorAll('.card__heading a').forEach((link) => {
            if (colourItem.dataset.productUrl) link.href = colourItem.dataset.productUrl;
            if (!colourItem.dataset.productTitle) return;
            const titleEl = link.querySelector('.card__product-title');
            if (titleEl) {
              titleEl.textContent = colourItem.dataset.productTitle;
            } else {
              link.textContent = colourItem.dataset.productTitle;
            }
          });

          // update image
          const variantImage = colourItem.dataset.variantImage;
          const maleImg = this.querySelector('.card__media img.image-male-1');
          const femaleImg = this.querySelector('.card__media img.image-female-1');
          const fallbackImg = this.querySelector('.card__media img:not(.card__media--hover-image)');

          if (document.body.classList.contains('gender-preference-male') && maleImg) {
            if (colourItem.dataset.variantMaleSrcset) maleImg.srcset = colourItem.dataset.variantMaleSrcset;
            if (variantImage) maleImg.src = variantImage;
          } else if (femaleImg) {
            if (colourItem.dataset.variantFemaleSrcset) femaleImg.srcset = colourItem.dataset.variantFemaleSrcset;
            if (variantImage) femaleImg.src = variantImage;
          } else if (fallbackImg && variantImage) {
            fallbackImg.src = variantImage;
            if (colourItem.dataset.variantFemaleSrcset) fallbackImg.srcset = colourItem.dataset.variantFemaleSrcset;
          }

          // get size variants
          const sizeVariantOptions = [
            {size: 'S', variantId: colourItem.dataset.variantS},
            {size: 'M', variantId: colourItem.dataset.variantM},
            {size: 'L', variantId: colourItem.dataset.variantL},
            {size: 'XL', variantId: colourItem.dataset.variantXl},
            {size: 'XXL', variantId: colourItem.dataset.variantXxl}
          ];

          // update size selectors
          sizeVariantOptions.forEach(variant => {
            // get size variant button
            const el = this.querySelector(`.card-variant-selector button[data-option-title="${variant.size}"]`);
            if (!el) return;
            // remove unavailable class
            el.closest('li').classList.remove('unavailable');

            // update data-id and add unavailable class if variant is sold out
            if (variant.variantId === '') {
              el.closest('li').classList.add('unavailable');
              el.dataset.id = variant.variantId;
            } else {
              el.dataset.id = variant.variantId;
            }

            // in case when on colour change the currently selected size is sold out, select first available size
            if(el.classList.contains('selected') && variant.variantId == '' ) {
              el.classList.remove('selected');
              let sizeVariants = this.querySelectorAll('.card-variant-selector button');
              for (let i = 0; i < sizeVariants.length; i++) {
                if (sizeVariants[i].dataset.id !== '') {
                  sizeVariants[i].click();
                  break;
                }
              }
            }
          });

        // size variant clicked
        } else if (sizeButton) {
          let sizeVariants = this.querySelectorAll('.card-variant-selector button');

          sizeVariants.forEach(variant => {
            variant.classList.remove('selected');
          });

          sizeButton.classList.add('selected');
          const currentSize = this.querySelector('variants-drawer-button span .variants-drawer__current-size') || this.querySelector('variants-drawer-button span');
          if (currentSize) currentSize.dataset.currentSize = sizeButton.innerHTML;
          if (currentSize && currentSize.classList.contains('variants-drawer__current-size')) {
            currentSize.textContent = sizeButton.innerHTML;
          }
        } else {
          return;
        }

        const selectedSize = this.querySelector('.card-variant-selector button.selected');
        const variantId = selectedSize?.dataset.id || colourItem?.dataset.variantId;
        if (!variantId) return;

        // if bundle pdp update form
        if (e.target.closest('.pdp-bundle-atc-form')) {
          let selectedProductCardIndex = [...document.querySelectorAll('.pdp-bundle-atc-form product-card')].indexOf(e.target.closest('product-card')) + 1;
          let shopTheLookForm = document.querySelector('.pdp-bundle-atc-form product-form')
          shopTheLookForm.querySelector(`input[name='items[${selectedProductCardIndex}][id]']`).value = variantId;
        // update shop the look form
        } else if (e.target.closest('shop-the-look-drawer')) {
          let selectedProductCardIndex = [...document.querySelectorAll('shop-the-look-drawer product-card')].indexOf(e.target.closest('product-card'))
          let shopTheLookForm = document.querySelector('shop-the-look-drawer product-form')
          shopTheLookForm.querySelector(`input[name='items[${selectedProductCardIndex}][id]']`).value = variantId;
        // update quick add form
        } else {
          const closestDrawer = e.target.closest('quick-add-drawer');
          const input = closestDrawer?.querySelector('.quick-add-drawer-input');
          if (input) input.value = variantId;
        }
      }

      selectColourway(productId) {
        if (!productId) return;
        const colourItem = this.querySelector(`.shop-the-look__colour-variant .product-group--item[data-product-id="${productId}"]`);
        if (!colourItem || colourItem.classList.contains('current')) return;
        this.updateShopTheLookForm({ target: colourItem });
        const colourVariant = colourItem.closest('.shop-the-look__colour-variant');
        const variantsDrawer = colourItem.closest('variants-drawer');
        if (variantsDrawer && colourVariant) {
          variantsDrawer.updateColourState({ currentTarget: colourVariant });
        }
      }
    }

    customElements.define('product-card', ProductCard)
  }
